import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface TransitProps {
  transitId: string;
  houseConsignmentIndex: number;
  file: File;
}

export const useUploadHouseConsignmentItems = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, houseConsignmentIndex, file }: TransitProps) => {
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      const result = await apiClient.transit.uploadHouseConsignmentItems.mutation({
        params: { transitId, houseConsignmentIndex: houseConsignmentIndex.toString() },
        body: formData,
      });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.transitId] });
      toast.success(`New house consignment items were uploaded!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error uploading the house consignment items!`);
    },
  });
};
